import { NERDLE_HOME, labsHomeUrl } from '../labs/labsNav'

// Persistent top bar on every labs screen (rendered by AdLayout).
//   - LEFT: the nerdle logo — ALWAYS links to the main nerdle site.
//   - RIGHT: a home icon — "up one level": inside a game it goes to the /labs home (the easiest
//     way back to the other labs games); on the /labs home itself it goes to the main nerdle site.
// Kept compact; not sticky (scrolls away) so the play area stays roomy.

// Are we on the /labs landing (no game slug), rather than inside a game?
const onLabsHome = (): boolean => {
  try {
    const seg = window.location.pathname.replace(/\/+$/, '').split('/').pop() || ''
    const inGame =
      ['24', 'cryptic', 'cryptic-easy', 'rebus'].includes(seg) ||
      /(crypticbeta|crypticeasybeta|rebusbeta)/.test(window.location.search)
    return !inGame
  } catch {
    return false
  }
}

export const TopNav = () => {
  const isHome = onLabsHome()
  const homeHref = isHome ? NERDLE_HOME : labsHomeUrl()
  return (
    <div className="relative flex items-center justify-between px-4 pt-3 pb-1">
      <a href={NERDLE_HOME} aria-label="nerdle home" className="inline-flex items-center">
        <img src={(process.env.PUBLIC_URL || '') + '/favicon.png'} alt="nerdle" className="h-7 w-7" />
      </a>
      {isHome && (
        <div className="pointer-events-none absolute left-1/2 -translate-x-1/2 select-none leading-none">
          <span className="nerdle-name text-2xl font-extrabold">nerdle</span>{' '}
          <span className="nerdle-sub-name text-2xl font-semibold text-gray-400">labs</span>
        </div>
      )}
      <a href={homeHref} aria-label="Home" className="text-gray-400 transition-colors hover:text-[#820458]">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-6 w-6"
          aria-hidden="true"
        >
          <path d="M3 11.5 12 4l9 7.5" />
          <path d="M5 10v9h5v-5h4v5h5v-9" />
        </svg>
      </a>
    </div>
  )
}
